module.exports = __webpack_public_path__ + "img/canonical-line-long.f338d1d9.svg";